import Inventory from "./Inventory.presenter";
export default Inventory;
